class SubscriptionWidget extends HTMLElement {
  constructor() {
    super()

    this.prevVariantID = undefined
    this.variantData = JSON.parse(this.querySelector("[data-variants]").textContent)
    this.section = document.querySelector(`#shopify-section-${this.dataset.section}`)
    this.purchaseOptionInputs = this.querySelectorAll(".js-purchase-option")
    this.sellingPlanInput = this.querySelector(".js-selling-plan")
    this.variantInputs = this.querySelectorAll(".js-product-variant")
    this.variantInput = document.querySelector("#product-select")
    this.productForm = document.getElementById(`product-form-${this.dataset.section}`)
    this.selectedValue = this.querySelector(".js-selected-value")
  }

  connectedCallback() {
    this.purchaseOptionInputs.forEach((el) =>
      el.addEventListener("input", this.onPurchaseOptionChange.bind(this))
    )
    if (this.variantInputs.length) {
      this.variantInputs.forEach((el) =>
        el.addEventListener("input", this.onVariantInputChange.bind(this))
      )
    } else {
      this.variantInput.addEventListener("change", this.onVariantInputChange.bind(this))
    }
  }

  onPurchaseOptionChange(e) {
    if (e.target.value === "subscription") {
      this.sellingPlanInput.removeAttribute("disabled")
      this.selectedValue.textContent = "Subscribe"
    } else {
      this.sellingPlanInput.setAttribute("disabled", true)
      this.selectedValue.textContent = "One Time"
    }
  }

  onVariantInputChange(e) {
    if (this.prevVariantID === e.target.value) return
    const id = e.target.value
    this.prevVariantID = id
    const variant = this.variantData.find((e) => e.id === +id)

    this.updateVariantInput(variant)
    this.toggleAddButton(variant)
    this.updatePrice(variant)
    this.updateURL(variant)
    this.updateSalesBadge(variant)
    this.updateVariantInfo(variant)
    const vs = document.querySelector("variant-selects")

    if (vs) {
      vs.dispatchEvent(
        new CustomEvent("variant:changed", {
          bubbles: true,
          detail: {
            id: variant.id,
          },
        })
      )
    }
  }

  updateVariantInput(variant) {
    const input = this.productForm?.querySelector('[name="id"]')

    if (input) input.value = variant.id
  }

  toggleAddButton(variant) {
    const addButton = this.productForm.querySelector('[name="add"]')
    const addButtonText = this.productForm.querySelector('[name="add"] > span')

    if (!addButton) return

    if (variant.available) {
      addButton.removeAttribute("disabled")
    } else {
      addButton.setAttribute("disabled", true)
    }

    if (!addButtonText) return

    addButtonText.innerHTML = variant.available
      ? window.variantStrings.addToCart
      : window.variantStrings.soldOut
  }

  updatePrice(variant) {
    this.querySelectorAll(".purchase-option__subscription .js-price-sale").forEach((el) => {
      el.innerHTML = variant.subscription_price_display
    })
    this.querySelectorAll(".purchase-option__onetime .js-price-sale").forEach(
      (el) => (el.innerHTML = variant.onetime_price_display)
    )
    this.querySelectorAll(".purchase-option__subscription .js-price-origin").forEach(
      (el) => (el.innerHTML = variant.price_display)
    )
    this.querySelectorAll(".purchase-option__onetime .js-price-origin").forEach(
      (el) => (el.innerHTML = variant.price_display)
    )
    // Hide or show the OTP origin price
    document
      .querySelectorAll(".purchase-option__onetime .purchase-option__price--origin")
      .forEach((el) => {
        if (el.innerHTML === variant.onetime_price_display) {
          el.classList.toggle("hidden", true)
        } else {
          el.classList.toggle("hidden", false)
        }
      })
  }

  updateSalesBadge({
    subscription_price_adjustment,
    otp_price_adjustment,
    sub_label_prefix,
    sub_label_suffix,
    otp_label_prefix,
    otp_label_suffix,
  }) {
    const subPercentOff = document.querySelector(".purchase-option__subscription .rc-percent_off")
    const otherPercentOff = document.querySelector(".purchase-option__onetime .rc-percent_off")

    if (subPercentOff) {
      if (subscription_price_adjustment) {
        subPercentOff.textContent = `${sub_label_prefix} ${subscription_price_adjustment}% ${sub_label_suffix}`
        subPercentOff.classList.remove("hidden")
      } else {
        subPercentOff.textContent = ``
        subPercentOff.classList.add("hidden")
      }
    }

    if (otherPercentOff) {
      if (otp_price_adjustment) {
        otherPercentOff.textContent = `${otp_label_prefix} ${otp_price_adjustment}% ${otp_label_suffix}`
        otherPercentOff.classList.remove("hidden")
      } else {
        otherPercentOff.textContent = ``
        otherPercentOff.classList.add("hidden")
      }
    }
  }

  updateVariantInfo(variant) {
    this.section.querySelectorAll(".product-tag-overlay-container").forEach((el) => {
      if (variant.image_tag) {
        el.innerHTML = `<div class="product-tag-overlay"><p class="special">${variant.image_tag}</p></div>`
      } else {
        el.innerHTML = ""
      }
    })

    this.querySelectorAll(".js-variant-benefit").forEach((el) => {
      el.classList[+el.dataset.variantId === +variant.id ? "remove" : "add"]("hidden")
    })
  }

  updateURL(variant) {
    const url = new URL(window.location)
    url.searchParams.set("variant", variant.id)
    window.history.replaceState({}, "", url)
  }
}

customElements.define("subscription-widget", SubscriptionWidget)